( function(global, $) {
    "use strict";

    var $container,
        tooltips;

    var clearTooltips = function() {
        var tooltips = $container.find('[gr-tooltip-simple]');
        for (var i = 0; i < tooltips.length; i++) {
            tooltips[i].classList.remove('is-active');
        }
    }

    var toogleTooltip = function(tooltip) {
        clearTooltips();
        tooltip.classList.toggle('is-active');
    }

    // app instantiation
    $('body').on('app.init', function(ev) {
        $container = $(ev.container);
        if ($container.find('[gr-tooltip-simple]').length) {

            tooltips = $container.find('[gr-tooltip-simple]');
            for (var i = 0; i < tooltips.length; i++) {
                tooltips[i].addEventListener('click', function() { toogleTooltip(this) });
            }

            $(document).click(function(event) {
                if(!$(event.target).closest('[gr-tooltip-simple]').length) {
                    clearTooltips();
                }
            });
        }
    });

}(window.groots, jQuery));
